module.exports = __webpack_public_path__ + "static/media/chrome-store.eb8baebb.svg";